var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-data-table',{staticClass:"elevation-1",attrs:{"items-per-page":10,"items":_vm.sangriaListMasked,"headers":_vm.headers,"id":"tableSangria"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }